import React from 'react';
import { useSiteData } from '../../context/SiteDataContext';
import { MessageCircle } from 'lucide-react';

const WhatsAppWidget = () => {
  const { settings } = useSiteData();
  const rawNumber = settings.support_whatsapp_number || '';
  
  // Format the number: remove any non-numeric characters except +
  const cleanNumber = rawNumber.replace(/[^0-9]/g, '');

  if (!cleanNumber) return null;

  const waUrl = `https://wa.me/${cleanNumber}`;

  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-between rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:scale-115 hover:shadow-2xl flex-row justify-center"
      aria-label="Contact support on WhatsApp"
      data-testid="whatsapp-widget"
    >
      <MessageCircle className="h-7 w-7 fill-white text-[#25D366]" />
      <span className="absolute -top-2 -right-1 flex h-4 w-4">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
        <span className="relative inline-flex h-4 w-4 rounded-full bg-emerald-500"></span>
      </span>
    </a>
  );
};

export default WhatsAppWidget;
